import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import {RouterModule} from '@angular/router';
import {FieldSchemaRoutes} from '@features/field-schema/field-schema.routes';
import {SharedModule} from '@shared/shared.module';
import {CommandService} from '@core/services/command.service';
import {PlatformApiProvider} from '@shared/services/platform-api-provider';
import {FieldSchemaApiProvider} from '@features/field-schema/field-schema-api-provider';
import {PlatformCommand} from '@shared/commands/command-base';
import {Api} from '@shared/constants/common-field.constants';
import {FieldSchemaHandler} from '@features/field-schema/services/field-schema-handler';
import {RootDynamicComponentHelper} from '@shared/helpers/root-dynamic-component-helper';



@NgModule({
  declarations: [],
  imports: [
    RouterModule.forChild(FieldSchemaRoutes),
    CommonModule,
    SharedModule
  ],
  exports: [
  ]
})
export class FieldSchemaModule {
  constructor(private commandService: CommandService,
              private platformApiProvider: PlatformApiProvider,
              private fieldSchemaHandler: FieldSchemaHandler) {
    this.platformApiProvider.registerAtTop(new FieldSchemaApiProvider());
    RootDynamicComponentHelper.register('FieldSchemaHandler', fieldSchemaHandler);

    const fieldSchemaToolLinkCommand = new PlatformCommand('CreateFieldSchemaToolLinkCommand', Api.Projects);
    fieldSchemaToolLinkCommand.fieldValues['ViewMode'] = 'IconView';
    this.commandService.registrPlatformLinkCommand('/field-schema', fieldSchemaToolLinkCommand);
  }
}
